import React, { Component } from "react";
import { Callout, Toggle } from "office-ui-fabric-react";
import {
  Persona,
  PersonaInitialsColor,
  PersonaSize,
} from "office-ui-fabric-react/lib/Persona";
import { Separator } from "office-ui-fabric-react";

import Offices from "./offices";

import { EventEmitter } from "./events";

import "./../styles/profile-section.css";
import avatar from "../images/AvatarMenu_defaultAvatarSmall.png";

const queryString = ((a) => {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
})(window.location.search.substr(1).split('&'));

class Profile extends Component {
  constructor(props: any) {
    super(props);
    this.state = {
      isCalloutVisible: false,
      open: true,
      image: "",
      name: "",
      email: "",
      updateOfficeURL: "",
      getOfficeURL: "",
      selectedView: "simple",
        isAdvance: false,
        hasv1Access: queryString['hv1'],
        hasv2Access: queryString['hv2']
    };

    this.personaElement = React.createRef();
  }

  onCalloutDismiss = () => {
    this.setState({ isCalloutVisible: false });
  };

  onShowMenuClicked = () => {
    this.setState({ isCalloutVisible: !this.state.isCalloutVisible });
  };

  componentDidMount() {
    this.getUserView();
    this.loadProfilePic();
    // if (typeof window !== 'undefined') {
    //     window.addEventListener('load-trigger', this.loadProfilePic);
    // }
  }

  componentWillUnmount() {
    // if (typeof window !== 'undefined') {
    //     window.removeEventListener('load-trigger', this.loadProfilePic);
    // }
  }

  loadProfilePic = () => {
    let userSession = JSON.parse(localStorage.getItem("userSession"));
    let apiURL = JSON.parse(localStorage.getItem("api"));

    this.setState({
      image: userSession.image,
      name: userSession.name,
      email: userSession.userName,
      getOfficeURL: apiURL.getoffices,
      updateOfficeURL: apiURL.updateoffices,
    });
  };

  onClick = () => {
    EventEmitter.dispatch("open-offices");
  };

  getUserView() {
    this.setState({
      selectedView: this.props.userView,
      isAdvance: this.props.userView === "advance" ? true : false,
    });
  }

  toggleView = () => {
    var userUI = this.state.selectedView === "advance" ? "simple" : "advance";

    this.setState(
      {
        isAdvance: this.state.selectedView === "advance" ? false : true,
        selectedView: userUI,
      },
      () => {
        localStorage.setItem("user-ui", userUI);
        EventEmitter.dispatch("save-ui");
      },
    );
  };

  render() {
    let image;

    if (this.state && this.state.image) {
      image = `data:image/jpeg;base64,${this.state.image}`;
      }

    let isToggleShow = (this.state.hasv1Access !== null && this.state.hasv1Access == "true" && this.state.hasv2Access !== null && this.state.hasv2Access == "true");

      return (
        <div className='profile-holder'>
        <Offices
          updateURL={this.state.updateOfficeURL}
          getofficeURL={this.state.getOfficeURL}
          useremail={this.state.email}
        ></Offices>
        <div className="profile-account">
          <a ref={this.personaElement}>
            <Persona
              onClick={this.onShowMenuClicked}
              initialsColor={PersonaInitialsColor.blue}
              size={PersonaSize.size48}
              text={this.state.name}
              hidePersonaDetails
              imageUrl={image}
            />
          </a>
        </div>
        {this.state.isCalloutVisible && (
          <Callout
            style={{ maxWidth: 300 }}
            role="alertdialog"
            gapSpace={0}
            target={this.personaElement.current}
            onDismiss={this.onCalloutDismiss}
            setInitialFocus={true}
            className="account-callout"
          >
            <div className="profile-content">
              <div className="profile-account-info">
                <Persona
                  initialsColor={PersonaInitialsColor.blue}
                  imageUrl={image}
                  secondaryText={this.state.email}
                  text={this.state.name}
                  size={PersonaSize.size72}
                />
              </div>
              <div className="profile-offices">
                <div className="profile-offices-item">
                  <div
                    onClick={(e) => this.onClick(e)}
                    className="profile-offices-header"
                  >
                    <div>Preferred Offices</div>
                  </div>
                  {isToggleShow ? <Separator /> : null}
                  {isToggleShow ? 
                  <div className="profile-offices-header">
                    <div>
                      New Dashboard
                      <Toggle
                        checked={this.state.isAdvance}
                        onText="On"
                        offText="Off"
                        onChange={this.toggleView}
                      />
                    </div>
                  </div> : null }
                </div>
              </div>
            </div>
          </Callout>
        )}
      </div>
    );
  }
}

export default Profile;
